export function ContactSection() {
  return (
    <section id="contact" className="pf-section pf-contact-section">
      <div className="pf-container">
        <div className="pf-section-head">
          <span className="eyebrow">Direct Contact &amp; Engagement</span>
          <h2>Official Automatrix Channels</h2>
          <p>
            Immediate advisory for autonomous agent architectures, enterprise automations, and technical scoping.
          </p>
        </div>

        <div className="contact-cards-grid">
          {/* WhatsApp 1 */}
          <a
            href="https://wa.me/5521988407505?text=Hello%20Lucas!%20I%20am%20reviewing%20your%20portfolio%20and%20would%20like%20to%20discuss%20an%20AI%20systems%20architecture."
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card whatsapp-card"
          >
            <div className="contact-card-icon">💬</div>
            <div className="contact-card-info">
              <span className="contact-channel-tag">Primary Executive WhatsApp · Global</span>
              <strong>+55 (21) 98840-7505</strong>
              <p>Direct channel with Lucas Alves · Strategic consultations &amp; system architecture</p>
            </div>
            <span className="contact-arrow">↗</span>
          </a>

          {/* WhatsApp 2 */}
          <a
            href="https://wa.me/5521974445234?text=Hello!%20I%20would%20like%20information%20regarding%20Automatrix%20solutions."
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card whatsapp-card"
          >
            <div className="contact-card-icon">📱</div>
            <div className="contact-card-info">
              <span className="contact-channel-tag">Operations WhatsApp · Support &amp; Sprints</span>
              <strong>+55 (21) 97444-5234</strong>
              <p>Operations channel and technical triaging for active client workflows</p>
            </div>
            <span className="contact-arrow">↗</span>
          </a>

          {/* Instagram */}
          <a
            href="https://instagram.com/automatrix.ia"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card instagram-card"
          >
            <div className="contact-card-icon">📸</div>
            <div className="contact-card-info">
              <span className="contact-channel-tag">Official Instagram</span>
              <strong>@automatrix.ia</strong>
              <p>Behind the scenes, AI systems drops, prompt engineering, and product demos</p>
            </div>
            <span className="contact-arrow">↗</span>
          </a>

          {/* GitHub */}
          <a
            href="https://github.com/Morfeu333"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card github-card"
          >
            <div className="contact-card-icon">🐙</div>
            <div className="contact-card-info">
              <span className="contact-channel-tag">GitHub · 168 Repositories</span>
              <strong>github.com/Morfeu333</strong>
              <p>Public codebases, agent orchestration runtimes, forks, and developer tooling</p>
            </div>
            <span className="contact-arrow">↗</span>
          </a>

          {/* Email */}
          <a
            href="mailto:lucas@automatrix-ia.com"
            className="contact-card email-card"
          >
            <div className="contact-card-icon">✉️</div>
            <div className="contact-card-info">
              <span className="contact-channel-tag">Corporate Email</span>
              <strong>lucas@automatrix-ia.com</strong>
              <p>Formal proposals, RFPs, and strategic enterprise partnerships</p>
            </div>
            <span className="contact-arrow">↗</span>
          </a>

          {/* GEO / Location */}
          <div className="contact-card geo-card">
            <div className="contact-card-icon">📍</div>
            <div className="contact-card-info">
              <span className="contact-channel-tag">Operating Headquarters &amp; Timezone</span>
              <strong>Rio de Janeiro / São Paulo · Brazil (GMT-3)</strong>
              <p>Global remote delivery for enterprises across the United States, Europe, and Latin America</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
